import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import axios from 'axios'
import i18n from './i18n'

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL || window.location.origin // Adjust this to your backend URL
axios.defaults.withCredentials = true

const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

const app = createApp(App)

app.config.errorHandler = (err, vm, info) => {
  console.error('Global error:', err)
  console.error('Error info:', info)
  store.commit('setError', 'An unexpected error occurred. Please try again.')
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      store.dispatch('logout')
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

// Initialize auth state from localStorage
store.dispatch('initializeAuth')

app.use(store).use(router).use(i18n).mount('#app')
